import React from 'react';
import styled from 'styled-components';
import theme from 'shared/assets/style/theme';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
export default function ErrorHandlingWrapper(props) {
  const { buttonClickHandler, closeModal, error, buttonText } = props;

  const supportCallBack = () => {
    closeModal(false);
    ENVIRONMENT_VARIABLES.ZENDESK_URL && window.open(ENVIRONMENT_VARIABLES.ZENDESK_URL, '_blank');
  };

  return (
    <div>
      <ServerError>{error}</ServerError>
      <ButtonWrapper onClick={() => (buttonClickHandler ? buttonClickHandler() : supportCallBack())}>
        <ImageButton src={require(asset`RoundedRect_Pink@3x.png`)} />
        <ButtonTextWrapper>{buttonText}</ButtonTextWrapper>
      </ButtonWrapper>
    </div>
  );
}

const ServerError = styled.p`
  font-size: 1.2rem;
  font-weight: 500;
  color: #fff;
  text-align: center;
  margin-bottom: 40px;
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  align-self: center;
  justify-content: center;
  display: flex;
`;

export const ImageButton = styled.img`
  width: 210px;
  cursor: pointer;
`;

export const ButtonTextWrapper = styled.p`
  position: absolute;
  cursor: pointer;
  margin: 0px;
  font-size: 1.3rem;
  font-weight: 800;
  -webkit-text-stroke: 1px navy;
  text-stroke: 1px ${theme.palette.primary[28]};
`;

